import { render } from "./router-icon.vue?vue&type=template&id=56d27572"
import script from "./router-icon.vue?vue&type=script&lang=js"
export * from "./router-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__